import { useRef, useState } from "react";
import { useDrag, useDrop } from "react-dnd";
import { AiFillCloseCircle, AiFillCheckCircle } from "react-icons/ai";
import { BsCircle } from "react-icons/bs";
import styles from "../../pages/AddImages/styles.module.sass";
import format from "date-fns/format";
const style = {
  border: "1px dashed transparent",
  width: 220,
  height: 220,
  backgroundColor: "white",
  cursor: "move",
};
export const Card = ({
  id,
  url,
  index,
  moveCard,
  handleDelete,
  handleAdd,
  approved,
  isAgent,
  toggleModal,
  date = null,
}) => {
  const ref = useRef(null);
  const [isScrollingUp, setIsScrollingUp] = useState(false);
  const [isScrollingDown, setIsScrollingDown] = useState(false);
  const [{ handlerId }, drop] = useDrop({
    accept: "CARD",
    collect(monitor) {
      return {
        handlerId: monitor.getHandlerId(),
      };
    },
    hover(item, monitor) {
      if (!ref.current) {
        return;
      }
      const dragIndex = item.index;
      const hoverIndex = index;
      // Don't replace items with themselves
      if (dragIndex === hoverIndex) {
        return;
      }
      // Determine rectangle on screen
      const hoverBoundingRect = ref.current?.getBoundingClientRect();
      // Get vertical middle
      const hoverMiddleY =
        (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
      // Determine mouse position
      const clientOffset = monitor.getClientOffset();
      // Get pixels to the top
      const hoverClientY = clientOffset.y - hoverBoundingRect.top;
      // Only perform the move when the mouse has crossed half of the items height
      // When dragging downwards, only move when the cursor is below 50%
      // When dragging upwards, only move when the cursor is above 50%
      // Dragging downwards
      if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
        return;
      }
      // Dragging upwards
      if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
        return;
      }
      // Time to actually perform the action
      moveCard(dragIndex, hoverIndex);
      // Note: we're mutating the monitor item here!
      // Generally it's better to avoid mutations,
      // but it's good here for the sake of performance
      // to avoid expensive index searches.
      item.index = hoverIndex;

      const containerRect = ref.current.getBoundingClientRect();
      const offsetY = monitor.getClientOffset().y - containerRect.top;
      const scrollThreshold = 70; // Adjust this value as needed
      const scrollSpeed = 10; // Adjust this value as needed

      if (offsetY < scrollThreshold) {
        setIsScrollingUp(true);
        setIsScrollingDown(false);
        const scrollContainer = ref.current.parentElement;
        scrollContainer.scrollTop -= scrollSpeed;
      } else if (containerRect.height - offsetY < scrollThreshold) {
        setIsScrollingUp(false);
        setIsScrollingDown(true);
        const scrollContainer = ref.current.parentElement;
        scrollContainer.scrollTop += scrollSpeed;
      } else {
        setIsScrollingUp(false);
        setIsScrollingDown(false);
      }
    },
  });
  const [{ isDragging }, drag] = useDrag({
    type: "CARD",
    item: () => {
      return { id, index };
    },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });
  const opacity = isDragging ? 0 : 1;
  drag(drop(ref));
  return (
    <div
      ref={ref}
      style={{ ...style, opacity }}
      data-handler-id={handlerId}
      className={styles.customClass}
    >
      <div className={styles.absoluteTitle}>
        {date ? format(new Date(date), "dd MMM yyyy, HH:mm:ss") : ""}
      </div>
      <div className={styles.absoluteClose} onClick={handleDelete}>
        <AiFillCloseCircle />
      </div>
      {!isAgent && (
        <div className={styles.absoluteAdd} onClick={handleAdd}>
          {!approved ? <BsCircle /> : <AiFillCheckCircle />}
        </div>
      )}
      {<img src={`${url}?${Math.random()}`} onClick={toggleModal} />}
    </div>
  );
};
